<template>
  <div>
    <avue-crud
      :option="taskTableOption"
      :data="taskTableData"
      :page.sync="page"
      @search-change="searchChange"
      @size-change="sizeChange"
      @current-change="currentChange"
      :row-style="rowStyle"
      ref="crud"
      highlight-current
    >
      <template slot="header">
        <div class="d-f p-10 justify-b align-c">
          <section class="d-f f-s-14">
            <div>
              <el-tag
                style="
                  background-color: rgb(238, 141, 37);
                  height: 12px;
                  width: 12px;
                  border-radius: 100%;
                  padding-right: 0px;
                  padding-left: 9px;
                "
                size="small"
              ></el-tag>
              <span style="color: #ee8d25; padding-right: 12px">已完成PE</span>
            </div>
            <div>
              <el-tag
                style="
                  background-color: #2bdb17;
                  height: 12px;
                  width: 12px;
                  border-radius: 100%;
                  padding-right: 0px;
                  padding-left: 9px;
                "
                size="small"
              ></el-tag>
              <span style="color: #2bdb17; padding-right: 12px">
                PE审核已通过
              </span>
            </div>
            <div>
              <el-tag
                style="
                  background-color: #2f863d;
                  height: 12px;
                  width: 12px;
                  border-radius: 100%;
                  padding-right: 0px;
                  padding-left: 9px;
                "
                size="small"
              ></el-tag>
              <span style="color: #2f863d; padding-right: 12px">
                质控已通过
              </span>
            </div>
          </section>
          <section>
            <el-input
              placeholder="请输入译文"
              v-model="translateSearchKey"
              @keyup.enter.native="searchChange"
              class="bg-white w-260 m-r-10"
            />
            <el-input
              placeholder="请输入原文"
              v-model="detailSearchKey"
              @keyup.enter.native="searchChange"
              class="bg-white w-260"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="searchChange"
              ></el-button>
            </el-input>
            <el-button
              type="primary"
              class="m-l-10"
              @click="exportComparision"
              :disabled="orderInfo.status != 2"
            >
              各环节译文对比导出
            </el-button>
            <el-button
              v-if="smartCheckUrl"
              type="primary"
              class="m-l-10"
              @click="exportSmartCheck"
              :disabled="orderInfo.status != 2"
            >
              智能检查结果导出
            </el-button>
          </section>
        </div>
      </template>
      <template slot-scope="scope" slot="srcText">
        <div style="word-break: break-word; font-size: 14px">
          <rich-text :jsonText="scope.row.srcText" readonly />
        </div>
      </template>
      <template slot-scope="scope" slot="mtText">
        <div style="word-break: break-word; font-size: 14px">
          <rich-text :jsonText="scope.row.mtText" readonly />
        </div>
      </template>
      <template slot-scope="scope" slot="peText">
        <!-- <div class="td-cell-bg"> -->
        <div
          style="background-color: unset"
          v-if="
            (scope.row.qcText != null && scope.row.qcText != '') ||
            scope.row.qcStatus === 3
          "
        >
          <div
            class="f-s-14 t-l p-l-10"
            style="word-break: break-word; color: #2f863d"
          >
            <rich-text
              :jsonText="
                scope.row.qcText != null ? scope.row.qcText : scope.row.peText
              "
              readonly
            />
          </div>
        </div>
        <div
          style="background-color: unset"
          v-else-if="
            scope.row.peText != null &&
            scope.row.qcStatus === 1 &&
            scope.row.lastAuditerId != null
          "
        >
          <div
            class="f-s-14 t-l p-l-10"
            style="word-break: break-word; color: #2bdb17"
          >
            <rich-text :jsonText="scope.row.peText" readonly />
          </div>
        </div>
        <div
          style="background-color: unset"
          v-else-if="scope.row.peTextTemp != null"
        >
          <div
            class="f-s-14 t-l p-l-10"
            style="word-break: break-word; color: #ee8d25"
          >
            <rich-text :jsonText="scope.row.peTextTemp" readonly />
          </div>
        </div>
        <div style="background-color: unset" v-else>
          <em class="c-333"></em>
        </div>
        <!-- </div> -->
      </template>
    </avue-crud>
  </div>
</template>

<script>
import { sentOption } from '@/const/crud/dot/order';
import { qcTaskSentencePage } from '@/api/dot/order';
import { analysisFile, smartCheckFile } from '@/api/dot/file';
import { statistics } from '../../../api/dot/flow';
import RichText from '@/components/rich-text';
import mockData from '@/components/rich-text/demo/mock.js';

export default {
  components: {
    RichText,
  },
  props: ['orderInfo', 'orderId', 'staParams'],
  data() {
    return {
      mockJson: mockData,
      taskTableOption: sentOption,
      taskTableData: [],
      orderIdChild: '',
      detailSearchKey: '',
      translateSearchKey: '',
      page: {
        pageSize: 100,
        size: 100,
        pagerCount: 5,
        current: 1,
        total: 0,
      },
      smartCheckUrl: '',
    };
  },
  mounted() {
    this.getSmartCheckResult();
  },

  watch: {
    orderId: function (n, o) {
      this.orderIdChild = n;
    },
  },

  methods: {
    //译文对比导出
    exportComparision() {
      analysisFile({
        orderId: this.orderInfo.id, //'1439140903043981314'
      }).then((res) => {
        // downloadFile(res.data.data.fileUrl, res.data.data.fileName)
        let re = /#|%|&|amp;/gi;
        window.location.href = this.$stringFormat(this.downUrl, [
          res.data.data.fileUrl,
          res.data.data.fileName.replace(re, ''),
        ]);
      });
      statistics(
        Object.assign(
          {
            event_name: '详细进度-各环节译文对比导出',
            event_type: 'click',
            class_name: 'analysisFile',
            class_url: '/dotadmin/dotadmin/file/analysisFile/',
            event_params: '{orderId: this.orderInfo.id}',
          },
          this.statistics,
        ),
      );
    },

    getSmartCheckResult() {
      return smartCheckFile({
        orderId: this.orderInfo.id,
      }).then((res) => {
        let re = /#|%|&|amp;/gi;
        if (res.data?.data && res.data.data.fileUrl) {
          this.smartCheckUrl = this.$stringFormat(this.downUrl, [
            res.data.data.fileUrl,
            res.data.data.fileName.replace(re, ''),
          ]);
        }
      });
    },
    //智能检查结果导出
    exportSmartCheck() {
      window.location.href = this.smartCheckUrl;
    },

    rowStyle({ row, column, rowIndex }) {
      if (row.repeatId != null || row.wordCount === 0) {
        return {
          background: '#f4f4f6 !important',
          color: '#666666',
        };
      }
    },

    searchChange() {
      this.page.current = 1;
      this.loadPage();
      statistics(
        Object.assign(
          {
            event_name: '详细进度-搜索',
            event_type: 'click',
          },
          this.statistics,
        ),
      );
    },

    sizeChange(pageSize) {
      this.page.size = pageSize;
      this.page.current = 1;
      this.loadPage();
    },

    currentChange(currentPage) {
      this.page.current = currentPage;
      this.loadPage();
    },

    loadPage() {
      qcTaskSentencePage(
        Object.assign(
          {
            current: this.page.current,
            size: this.page.size,
          },
          {
            orderId: this.$route.params.id,
            srcText: this.detailSearchKey,
            tranText: this.translateSearchKey,
          },
        ),
      ).then((response) => {
        console.log(response);
        let tmpe = [];
        this.taskTableData = [];
        response.data.data.records.forEach((ele) => {
          tmpe.push(ele);
        });
        Promise.all(response.data.data.records).then(() => {
          this.page = response.data.data;
          this.taskTableData = tmpe;
          this.page.total = response.data.data.total;
        });
      });
    },
  },
};
</script>
<style lang="scss">
.el-drawer {
  overflow-y: auto;

  .note {
    font-size: 14px;
    padding-left: 20px;
    margin: 0 0 20px 0;
  }
}
</style>
